import {
  analyzeClusters,
  analyzeColors,
  analyzeOverlaps,
  analyzeSpacing,
  analyzeTypography,
  diffApply,
  diffShow,
  lint,
  lintFix
} from './analyze'
import { designToComponentMap, designToTokens } from './codegen'
import {
  createComponent,
  createInstance,
  createPage,
  createShape,
  createSlice,
  createVector,
  exposeInstanceSwap,
  combineAsVariants,
  createSlot,
  fetchIconsTool,
  getBehaviour,
  importSVG,
  insertIcon,
  searchIconsTool,
  setBehaviour
} from './create'
import {
  setBlend,
  setConstraints,
  setEffects,
  setFont,
  setFontRange,
  setImageFill,
  setLocked,
  setMinMax,
  setOpacity,
  setRotation,
  setStrokeAlign,
  setTextResize,
  setVisible
} from './modify'
import {
  getComponents,
  getCurrentPage,
  getFontStatus,
  getPageTree,
  insertLibraryComponent,
  listAvailableFonts,
  listFonts,
  listLibraries,
  listPages,
  pageBounds,
  queryNodes,
  selectNodes,
  switchPage
} from './read'
import type { ToolDef } from './schema'
import {
  arrangeNodes,
  cloneNode,
  flattenNodes,
  groupNodes,
  nodeAncestors,
  nodeBindings,
  nodeBounds,
  nodeChildren,
  nodeMove,
  nodeReplaceWith,
  nodeToComponent,
  nodeTree,
  renameNode,
  ungroupNode
} from './structure'
import {
  bindVariable,
  createCollection,
  createVariable,
  deleteCollection,
  deleteVariable,
  findVariables,
  getCollection,
  getVariable,
  listCollections,
  listVariables,
  setVariable,
  unbindVariable
} from './variables'
import {
  booleanExclude,
  booleanIntersect,
  booleanSubtract,
  booleanUnion,
  exportImage,
  exportPDF,
  exportSVG,
  pathFlip,
  pathGet,
  pathMove,
  pathScale,
  pathSet,
  viewportGet,
  viewportSet
} from './vector'

/**
 * Extended tools not in CORE_TOOLS — variables, vector ops, analysis,
 * codegen, advanced structure, path manipulation, etc.
 */
export const EXTENDED_TOOLS: ToolDef[] = [
  // Read (advanced)
  getPageTree,
  getCurrentPage,
  listPages,
  selectNodes,
  queryNodes,
  getComponents,
  listLibraries,
  insertLibraryComponent,
  switchPage,
  pageBounds,
  getFontStatus,
  listFonts,
  listAvailableFonts,
  // Create (advanced)
  createShape,
  searchIconsTool,
  insertIcon,
  fetchIconsTool,
  combineAsVariants,
  createComponent,
  createInstance,
  exposeInstanceSwap,
  createSlot,
  getBehaviour,
  setBehaviour,
  createPage,
  createVector,
  createSlice,
  importSVG,
  // Modify (advanced)
  setEffects,
  setOpacity,
  setFont,
  setVisible,
  setConstraints,
  setRotation,
  setMinMax,
  setFontRange,
  setTextResize,
  setBlend,
  setLocked,
  setStrokeAlign,
  setImageFill,
  // Structure (advanced)
  cloneNode,
  nodeMove,
  renameNode,
  groupNodes,
  ungroupNode,
  flattenNodes,
  nodeToComponent,
  nodeBounds,
  nodeAncestors,
  nodeChildren,
  nodeTree,
  nodeBindings,
  nodeReplaceWith,
  arrangeNodes,
  // Variables
  listVariables,
  listCollections,
  getVariable,
  findVariables,
  createVariable,
  setVariable,
  deleteVariable,
  bindVariable,
  unbindVariable,
  getCollection,
  createCollection,
  deleteCollection,
  // Vector & export
  booleanUnion,
  booleanSubtract,
  booleanIntersect,
  booleanExclude,
  pathGet,
  pathSet,
  pathScale,
  pathFlip,
  pathMove,
  viewportGet,
  viewportSet,
  exportSVG,
  exportPDF,
  exportImage,
  // Analyze & diff
  analyzeColors,
  analyzeTypography,
  lint,
  lintFix,
  analyzeSpacing,
  analyzeClusters,
  analyzeOverlaps,
  diffShow,
  diffApply,
  // Codegen
  designToTokens,
  designToComponentMap
]
